import './styles.sass';

import React from 'react';
import PropTypes from 'prop-types';
import { Route, Routes } from 'react-router-dom';
import withLocation from 'components/withLocation';
import withFeatureFlags from 'components/Flipper/withFeatureFlags';
import FooterLinks from 'components/FooterLinks';

import Currents from './Currents';
import Highlights from './Highlights';
import Outputs from './Outputs';
import Timeline from './Timeline';
import Demographics from './Demographics';
import Mentions from './Mentions';
import Journals from './Journals';
import MentionSources from './MentionSources';
import ErrorBoundary from 'components/Explorer/ErrorBoundary';

class ContentPanel extends React.Component {
  static propTypes = {
    onRouteChangeUpdate: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    featureFlags: PropTypes.array
  };

  render() {
    return (
      <main className="Explorer-ContentPanel" id="main-content" tabIndex="-1">
        <ErrorBoundary message={I18n.t('Explorer.page_error')} resetKey={this.props.location.key}>
          {window.current_user.librarian ? <Outputs /> : this.routes}
        </ErrorBoundary>
        {this.footer}
      </main>
    );
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.props.onRouteChangeUpdate();
    }
  }

  get routes() {
    return (
      <Routes>
        {this.props.featureFlags?.includes('currents') && <Route path="/currents" element={<Currents />} />}
        <Route path="/highlights" element={<Highlights />} />
        <Route path="/outputs" element={<Outputs />} />
        <Route path="/timeline" element={<Timeline />} />
        <Route path="/demographics" element={<Demographics />} />
        <Route path="/mentions" element={<Mentions />} />
        <Route path="/journals" element={<Journals />} />
        <Route path="/mention_sources" element={<MentionSources />} />
      </Routes>
    );
  }

  get footer() {
    return (
      <footer>
        <div className="Explorer-footer">
          <p>
            <a
              className="info"
              href="https://help.altmetric.com/en/articles/9803777"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={I18n.t('Explorer.snapshot_help_link')}
            ></a>
            {I18n.htmlSafe('Explorer.snapshot_info', {
              lastSnapshot: window.current_user.last_snapshot,
              nextSnapshot: window.current_user.next_snapshot,
              dimensionsUpdate: '1 day ago'
            })}
          </p>
          <p>{I18n.htmlSafe('Explorer.twitter_info')}</p>
        </div>
        <FooterLinks />
      </footer>
    );
  }
}

export default withLocation(withFeatureFlags(ContentPanel));
